import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AuthenticationService } from '../authentication/authentication.service';

@Injectable()
export class JwtInterceptor implements HttpInterceptor {

    constructor(private _authenticationService: AuthenticationService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const isValidToken: boolean = this._authenticationService.isValidToken(this._authenticationService.tokenValue);
        if (isValidToken && this._authenticationService.tokenValue.access_token) {
            request = request.clone({
                setHeaders: {
                    Authorization: `Bearer ${this._authenticationService.tokenValue.access_token}`
                }
            });
        }

        return next.handle(request);
    }
}